import React, { useState } from 'react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import FollowUsRightContent1 from '../FollowUsRightContent1';
import { cn } from '@/shared/utils/shadcn';
import FollowUsRightContent2 from '../FollowUsRightContent2';
import useMobileDetect from '@/lib/hooks/useMobileDetect';

const FollowUs = () => {
  const t = useTranslations();
  const { isMobile } = useMobileDetect();
  const [showH5QRCode, setShowH5QRCode] = useState<string | null>(null); // H5关注我们二维码显示
  const [followUsKey, setFollowUsKey] = useState<string>('video');

  const followUsList = [
    {
      key: 'video',
      name: '视频',
      logoImage: '/images/home/videoIcon.png',
      content: (
        <div className="h-full w-full overflow-hidden rounded-[20px] max-md:rounded-xl">
          <iframe
            className="h-full w-full"
            src="//player.bilibili.com/player.html?isOutside=true&aid=116134070257573&bvid=BV1TKfeBWEVZ&cid=36290365024&p=1"
            scrolling="no"
          ></iframe>
        </div>
      ),
      bgColor: '#E4E7F7',
    },
    {
      key: 'xiaohongshu',
      name: '小红书',
      logoImage: '/images/home/xiaohongshu.png',
      qrCodeImages: ['/images/home/xiaohongshuQrcode.jpg'],
      content: (
        <FollowUsRightContent1
          qrCodeImageUrl={'/images/home/xiaohongshuQrcode.jpg'}
          url={''}
          mediaName={['文卷看见加拿大']}
        />
      ),
      bgColor: '#ffd9d9',
      mediaName: ['文卷看见加拿大'],
    },
    {
      key: 'weChat',
      name: '微信',
      logoImage: '/images/home/weChat.png',
      qrCodeImages: ['/images/footer/wechatNumber1.png', '/images/footer/wechatNumber2.png'],
      content: (
        <FollowUsRightContent2
          qrCodeImageUrls={['/images/footer/wechatNumber1.png', '/images/footer/wechatNumber2.png']}
          mediaName={['星环yangyang', '看见星环小助理']}
        />
      ),
      bgColor: '#E5F4EA',
      mediaName: ['星环yangyang', '看见星环小助理'],
    },
    {
      key: 'contactUsLogo',
      name: 'contactUsLogo',
      logoImage: '/images/home/contactUsLogo.png',
      qrCodeImages: ['/images/home/contactUsLogoQrcode1.png', '/images/home/contactUsLogoQrcode.png'],
      content: (
        <FollowUsRightContent2
          qrCodeImageUrls={['/images/home/contactUsLogoQrcode1.png', '/images/home/contactUsLogoQrcode.png']}
          mediaName={['文卷看见加拿大', '加拿大星环集团']}
        />
      ),
      bgColor: '#FEECDB',
      mediaName: ['文卷看见加拿大', '加拿大星环集团'],
    },
    {
      key: 'youTube',
      name: 'youTube',
      logoImage: '/images/home/youTube.png',
      url: 'https://www.youtube.com/@Canada_Insight',
      qrCodeImages: ['/images/home/youtubeQrcode.png'],
      content: (
        <FollowUsRightContent1
          qrCodeImageUrl={'/images/home/youtubeQrcode.png'}
          url={'https://www.youtube.com/@Canada_Insight'}
        />
      ),
      bgColor: '#D2D2D2',
    },
    {
      key: 'zhihu',
      name: 'zhihu',
      logoImage: '/images/home/zhihu.png',
      url: 'https://www.zhihu.com/org/xing-huan-yi-min-liu-xue',
      qrCodeImages: ['/images/home/zhihuQrcode.png'],
      content: (
        <FollowUsRightContent1
          qrCodeImageUrl={'/images/home/zhihuQrcode.png'}
          url={'https://www.zhihu.com/org/xing-huan-yi-min-liu-xue'}
          h5QrCodeBottom
        />
      ),
      bgColor: '#D2E9FE',
    },
    {
      key: 'bilibili',
      name: 'bilibili',
      logoImage: '/images/home/bilibili.png',
      url: 'https://space.bilibili.com/1793934549',
      qrCodeImages: ['/images/home/bilibiliQrcode.png'],
      content: (
        <FollowUsRightContent1
          qrCodeImageUrl={'/images/home/bilibiliQrcode.png'}
          url={'https://space.bilibili.com/1793934549'}
          h5QrCodeBottom
        />
      ),
      bgColor: '#FCDFE9',
    },
    {
      key: 'facebook',
      name: 'facebook',
      logoImage: '/images/home/facebook.png',
      url: 'https://www.facebook.com/profile.php?id=100057589413759',
      qrCodeImages: ['/images/home/facebookQrcode.png'],
      content: (
        <FollowUsRightContent1
          qrCodeImageUrl={'/images/home/facebookQrcode.png'}
          url={'https://www.facebook.com/profile.php?id=100057589413759'}
          h5QrCodeBottom
        />
      ),
      bgColor: '#E0E6F2',
    },
  ];

  return (
    <div className="w-full">
      {/* 关注我们 */}
      <div className="mb-[80px] box-border w-full px-[10.192vw] max-md:px-4">
        <div className="mb-5 text-[46px] font-semibold leading-[46px] text-[#111111] max-md:mb-6 max-md:text-lg max-md:leading-[18px]">
          {t('Home.followUs')}
        </div>
        <div className="mb-[34px] text-[36px] font-extrabold uppercase leading-[36px] text-[#E2E2E2] max-md:hidden">
          {t('Home.followUsEnglishText')}
        </div>
        <div className="mb-[80px] text-xl font-normal leading-5 text-[#666666] max-md:hidden">
          {t('Home.followUsEnglishTextDescription')}
        </div>
        <div className="flex w-full flex-row justify-start max-md:flex-col">
          <div
            className={cn('grid w-[47%] grid-cols-3 gap-6 pr-[10%] max-md:w-full max-md:grid-cols-5 max-md:pr-0', {
              'max-md:order-2':
                (followUsKey === 'video' ||
                  followUsKey === 'xiaohongshu' ||
                  followUsKey === 'weChat' ||
                  followUsKey === 'contactUsLogo' ||
                  followUsKey === 'youTube') &&
                isMobile,
              'max-md:order-1':
                (followUsKey === 'zhihu' || followUsKey === 'bilibili' || followUsKey === 'facebook') && isMobile,
            })}
          >
            {followUsList.map((item) => {
              return (
                <div key={item.key} className="flex flex-col items-center">
                  <div
                    className={
                      'group relative flex size-[6.864vw] cursor-pointer flex-col items-center justify-center rounded-full max-md:size-[13.3vw]'
                    }
                    onClick={() => setFollowUsKey(item.key)}
                  >
                    <div
                      style={{ backgroundColor: item.bgColor }}
                      className={cn('hidden h-full w-full rounded-full group-hover:block', {
                        block: item.key === followUsKey,
                      })}
                    ></div>
                    <Image
                      src={`${item.logoImage}`}
                      alt="image"
                      width={200}
                      height={200}
                      className="absolute left-1/2 top-1/2 size-[5.2vw] -translate-x-1/2 -translate-y-1/2 max-md:size-[9.975vw]"
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className={cn('aspect-[802/423] w-[53%] max-md:aspect-[626/352] max-md:w-full', {
              'max-md:order-1 max-md:mb-6':
                (followUsKey === 'video' ||
                  followUsKey === 'xiaohongshu' ||
                  followUsKey === 'weChat' ||
                  followUsKey === 'contactUsLogo' ||
                  followUsKey === 'youTube') &&
                isMobile,
              'max-md:order-2 max-md:mt-6':
                (followUsKey === 'zhihu' || followUsKey === 'bilibili' || followUsKey === 'facebook') && isMobile,
            })}
          >
            {followUsList.find((item) => item.key === followUsKey)?.content}
          </div>
        </div>
      </div>
      {showH5QRCode && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 md:hidden"
          onClick={() => setShowH5QRCode(null)}
        >
          <div className="relative" onClick={(e) => e.stopPropagation()}>
            {
              // eslint-disable-next-line @next/next/no-img-element
              <img src={showH5QRCode} width={250} height={250} className="size-[250px]" alt="qrcode" />
            }
            {/* <div
              className="absolute -right-3 -top-3 flex size-8 cursor-pointer items-center justify-center rounded-full bg-white"
              onClick={() => setShowH5QRCode(null)}
            >
              <Image src={'/images/home/close.png'} width={16} height={16} className="size-4" alt="close" />
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default FollowUs;
